module.exports = __webpack_public_path__ + "img/LI.e67f6409.svg";